//libs
import React from "react";

//helper
import cx from "classnames";

//styles
import S from "./style.module.scss";

//constants
import {
  MEMBER_PROFILE,
  PROVIDER_PROFILE,
  STRINGS,
} from "src/shared/constants";

//components
import { useHistory } from "react-router-dom";
import moment from "moment";

const RecentUsersTable = ({ data = [], loading = false }) => {
  const history = useHistory();

  return (
    <div className={S.tableContainer}>
      {!!!data.length && !!!loading ? (
        <p className={S.noData}>{STRINGS.NO_USERS_FOUND}</p>
      ) : (
        <table className={S.usersTable}>
          <thead>
            <tr className={cx(S.usersTableRow, S.usersTableHeading)}>
              <th>
                <span className={S.usersTableText}>ID</span>
              </th>
              <th>
                <span className={S.usersTableText}>Name</span>
              </th>
              <th>
                <span className={S.usersTableText}>Gender</span>
              </th>
              <th>
                <span className={S.usersTableText}>Joined on</span>
              </th>
              <th>
                <span className={S.usersTableText}>Status</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((d) => {
              const Path = d.role === 4 ? PROVIDER_PROFILE : MEMBER_PROFILE;
              return (
                <tr
                  key={d.id}
                  className={S.usersTableRow}
                  onClick={() => history.push({ pathname: Path, search: d.id })}
                >
                  <td>
                    <span className={S.usersTableText}>
                      {d.uniqueId || STRINGS.EMPTY_DATA}
                    </span>
                  </td>
                  <td>
                    <span className={S.usersTableText}>
                      {d.fullName || STRINGS.EMPTY_DATA}
                    </span>
                  </td>
                  <td>
                    <span className={S.usersTableText}>
                      {d.gender || STRINGS.EMPTY_DATA}
                    </span>
                  </td>
                  <td>
                    <span className={S.usersTableText}>
                      {d.dob
                        ? moment(d.createdAt).format("MMM Do, YYYY")
                        : STRINGS.EMPTY_DATA}
                    </span>
                  </td>
                  <td>
                    <div
                      className={cx(
                        S.status,
                        d.userCreatedOwnPassword
                          ? S.statusActive
                          : S.statusPending
                      )}
                    >
                      {d.userCreatedOwnPassword ? "Active" : "Pending"}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default React.memo(RecentUsersTable);
